import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import VueMaterial from 'vue-material'
import VueAnalytics from 'vue-analytics'

Vue.use(VueMaterial)

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_ANALYTICS_TRACKING_CODE,
  router
})

require('./router-transitions')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
